import React from "react";

function Notice() {
  return (
    <div className="flex items-center justify-between px-24 py-10 mb-10">
      <h1 className="max-w-lg text-2xl text-[#D7D7D7] font-medium tracking-wide ">
        Start your business today for $0+ state fees
      </h1>
      <div className="flex space-x-4 text-xs">
        <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl">
          <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] px-6 py-3">
            Contact Us
          </div>
        </div>

        <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl">
          <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] pl-6 pr-3 py-2">
            <div className="flex items-center space-x-3">
              <span>Get started</span>
              <div className="flex items-center justify-center w-6 h-6 text-xs font-semibold text-black bg-white rounded-full">
                +
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notice;
